import { Accounts } from '@yuno/types'
import { useContext, useEffect, useState } from 'react'
import { ContainerContext } from '../yuno-dashboard-container-mfe'

export const useVerifyPermission = (permission) => {
  const { permissions } = useContext<Accounts.PermissionsList>(ContainerContext)
  const [allowed, setAllowed] = useState(false)

  useEffect(() => {
    setAllowed(permissions?.includes(permission))
  }, [permissions, permission])

  return {
    allowed,
  }
}
